export const industryCodeFields = ["two_digit_sic_code", "four_digit_sic_code", "eight_digit_sic_code", "naics_code"] as const;
export type IndustryCodeField = (typeof industryCodeFields)[number];
export type UccIndustryCodeField = IndustryCodeField | `secured_party_${IndustryCodeField}`;
export type IndustryCodeCatalog = Record<IndustryCodeField, readonly (readonly string[])[]>;

export function isIndustryClassificationField(field: string) {
	return /^(secured_party_)?(naics|two_digit_sic|four_digit_sic|eight_digit_sic)_(code|description)$/.test(field);
}

export function getIndustryCodeDefinitions(catalog: IndustryCodeCatalog | null, mode: "debtor" | "secured_party") {
	const labels: Record<IndustryCodeField, string> = {
		two_digit_sic_code: "2-Digit SIC",
		four_digit_sic_code: "4-Digit SIC",
		eight_digit_sic_code: "8-Digit SIC",
		naics_code: "NAICS",
	};
	return industryCodeFields.map((key) => {
		const entries = catalog?.[key] ?? [];
		return {
			field: (mode === "secured_party" ? `secured_party_${key}` : key) as UccIndustryCodeField,
			label: labels[key],
			shortLabel: labels[key],
			options: entries.map(([code]) => code),
			optionLabels: Object.fromEntries(entries.map(([code, description]) => [code, `${code}: ${description}`])),
		};
	});
}
